import { typography } from '@dentalux/ui-library-core'
import { Theme } from '@mui/material/styles'
import { createUseStyles } from 'react-jss'
import { forDesktopUp, forPhoneOnly } from 'src/config/mediaQueries'
import { forTabletPortraitUp } from 'src/config/mediaQueries'

export default createUseStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    maxWidth: 930,
    padding: [0, 108],
    margin: [76, 'auto', 0],
    [forPhoneOnly]: {
      margin: [0, 16],
      padding: 0,
    },
  },
  imageContainer: {
    display: 'none',
    [forDesktopUp]: {
      maxWidth: 295,
      display: 'initial',
    },
  },
  image: {
    width: '100%',
    height: 'auto',
  },
  title: {
    ...typography['Lato H4 Bold'],
    marginBottom: 24,
    [forPhoneOnly]: {
      ...typography['Lato H5 Bold'],
    },
  },
  info: {
    ...typography['Lato H5'],
    display: 'inline',
    [forPhoneOnly]: {
      ...typography['Lato Body 1'],
    },
  },
  oldPatientInfo: {
    width: '100%',
    display: 'flex',
  },
  oldPatientInfoContent: {
    maxWidth: 576,
    ...typography['Lato Body 1'],
    [forPhoneOnly]: {
      ...typography['Lato Body 2'],
    },
  },
  phoneNumber: {
    color: theme.palette.primary.main, // aqua -> primary
    ...typography['Lato H5'],
    display: 'inline',
    fontWeight: 700,
    [forPhoneOnly]: {
      ...typography['Lato Body 1'],
      fontWeight: 700,
    },
  },
  smsSentTo: {
    [forPhoneOnly]: {
      display: 'inline-block',
      marginTop: 14,
    },
  },
  oldPatientPhoneNumber: {
    ...typography['Lato Emphasized 1'],
    [forPhoneOnly]: {
      ...typography['Lato Emphasized 2'],
    },
  },
  errorContainer: {
    marginTop: 32,
    width: 'fit-content',
  },
  codeInputContainer: {
    display: 'flex',
    marginTop: 32,
    marginBottom: 24,
    [forPhoneOnly]: {
      marginTop: 24,
    },
  },
  verifyText: {
    ...typography['Lato Link 1'],
    color: theme.palette.primary.main, // aqua -> primary
  },
  verifyTextHover: {
    cursor: 'pointer',
  },
  notYourNumber: {
    marginTop: 4,
    display: 'inline-block',
    cursor: 'pointer',
    ...typography['Lato Link 1'],
    color: theme.palette.primary.main, // aqua -> primary
    [forPhoneOnly]: {
      ...typography['Lato Link 2'],
    },
  },
  oldPatientTitle: {
    ...typography['Lato H4 Bold'],
    marginBottom: 24,
    [forPhoneOnly]: {
      display: 'none',
    },
  },
  error: {
    marginTop: [20],

    [forTabletPortraitUp]: {
      marginRight: [40],
    },
  },
}))
